import React, { type ReactElement, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles.scss";
import {
  faEye,
  faEyeSlash,
  type IconDefinition
} from "@fortawesome/free-solid-svg-icons";

interface Props {
  id?: string;
  type?: string;
  value?: string | number;
  label?: string | any;
  placeholder?: string;
  msg?: string;
  error?: boolean;
  errorMsg?: string;
  rows?: number;
  min?: number;
  max?: number;
  maxLength?: number;
  step?: number;
  onChange?: any;
  name?: string;
  innerIcon?: IconDefinition | ReactElement<any, any>;
  outerIcon?: IconDefinition | ReactElement<any, any>;
  disabled?: boolean;
  onBlur?: any;
  className?: string;
  required?: boolean;
  tabIndex?: number;
  resize?: string;
  inline?: boolean;
}

interface KC_VisibilityContainerI {
  visibility: boolean;
  handleVisibility: () => void;
}

const KC_VisibilityContainer = ({
  visibility,
  handleVisibility
}: KC_VisibilityContainerI) => {
  return (
    <FontAwesomeIcon
      color="grey"
      onClick={handleVisibility}
      icon={visibility ? faEyeSlash : faEye}
      title="visibility"
      cursor="pointer"
      size="lg"
      style={{
        position: "absolute",
        right: -30
      }}
    />
  );
};

export default function KC_FormInput(props: Props) {
  const [visibility, setVisibility] = useState<boolean>(false);

  function handleVisibility() {
    setVisibility((previousVisibility) => !previousVisibility);
  }

  return (
    <div className={`kc-input ${props.inline ? "d-flex" : ""}`}>
      {!!props.label && (
        <span className={`kc-input-label ${props.inline ? "w-25" : ""}`}>
          {props.label}
        </span>
      )}
      {!!props.msg && <span className="kc-input-msg">{props.msg}</span>}
      {props.type === "textarea" && (
        <textarea
          id={props.id}
          className={`form-control ${
            props.error ? "kc-input-input-error" : ""
          } ${props.className || ""}`}
          value={props.value}
          placeholder={props.placeholder}
          rows={props.rows || 4}
          onChange={(e) => props.onChange && props.onChange(e)}
          onBlur={(e) => props.onBlur && props.onBlur(e)}
          required={props.required || false}
          // @ts-expect-error
          style={{ resize: props.resize || "none" }}
        />
      )}
      {props.type !== "textarea" && (
        <div className={"kc-input-wrap"}>
          <input
            id={props.id}
            className={`form-control ${
              props.error ? "kc-input-input-error" : ""
            } ${props.className || ""}`}
            onChange={
              props.onChange
                ? (e: React.SyntheticEvent) => props.onChange(e)
                : () => {}
            }
            onBlur={
              props.onBlur
                ? (e: React.SyntheticEvent) => props.onBlur(e)
                : () => {}
            }
            type={props.type && !visibility ? props.type : "text"}
            value={props.value}
            name={props.name}
            placeholder={props.placeholder}
            min={props.type === "number" ? props.min : undefined}
            max={props.type === "number" ? props.max : undefined}
            step={props.type === "number" ? props.step : undefined}
            maxLength={props.maxLength}
            disabled={props.disabled}
            required={props.required || false}
            tabIndex={props.tabIndex}
          />
          {props.innerIcon != null || null}
          {props.type === "password" ? (
            <KC_VisibilityContainer
              handleVisibility={handleVisibility}
              visibility={visibility}
            />
          ) : null}
        </div>
      )}
      {!!props.errorMsg && (
        <span className="kc-input-error-msg">{props.errorMsg}</span>
      )}
    </div>
  );
}
